import React from "react";
import "./NotFound.css";

export default () => <div className="NotFound">
                       <h3>Sorry, this page does not exist within the QAT CRM Platform... yet!</h3>
                     </div>;
